import { useEffect, useLayoutEffect, useState } from "react";
import useQuery from "../../../hooks/useQuery";
import useRoadmaps from "./useRoadmaps";
/**
 * Хук для акцентирования отображения маршрута на карте при наличии параметров city_id и NPART_ID
 * @returns {boolean} - Флаг, указывающий, был ли маршрут акцентирован
 */
function useQueryRoute() {
    const query = useQuery();
    const { showRoadmap } = useRoadmaps();

    const [dataQueryRoute, setData] = useState<{ npartId: string, cityId: string } | null>(null);

    useEffect(() => {
        const cityId = query.get("city_id");
        const npartId = query.get("NPART_ID");

        if (cityId && npartId) {
            setData({ npartId, cityId })
        } else {
            setData(undefined);
        }
    }, [query]);

    return ({
        dataQueryRoute
    })
}

export default useQueryRoute;